export default __webpack_public_path__ + "static/media/logo.6f6368c1.png";